import React from "react";
import { useTranslation } from "react-i18next";
import HelpSectionSliderSectionItemPure from "./help-section-slider-section-item.pure";
import HelpSectionSliderFaqItemPure from "./help-section-slider-faqs-item.pure";
import HelpSectionSliderVideosItemPure from "./help-section-slider-videos-item.pure";
// import { PostBlogPure } from "../../pures";
import "./help-section-slider.pure.css";
import { useEffect, useState } from "react";

const HelpSectionSliderPure = (props) => {
  const { t } = useTranslation();
  const {
    showHelpSection,
    initializeHelpSection,
  } = props;

  const [scrollY, setScrollY] = useState(60)
  const [active, setActive] = useState(false);

  useEffect(() => {
    window.addEventListener("scroll", () => {
      if (window.scrollY > 60) {
        setScrollY(0)
      } else {
        setScrollY(60)
      }
    });
  }, [window.scrollY])


  return (
    <div className={`${initializeHelpSection ? "" : "helpSectionPanel hide"}`}>
      <div style={{ marginTop: scrollY }} className={`helpSectionPanel ${showHelpSection ? "open" : ""} ${scrollY === 0 ? "scrolled" : "unscroll"}`}>
        <iframe onMouseEnter={() => setActive(true)} onMouseLeave={() => setActive(false)} className={`atix-iframe ${scrollY !== 0 ? "scrolled" : "unscroll"} ${active ? "active" : ""}`} src={`${process.env.REACT_APP_ATIX_CHATBOT_MAIN_URL}${process.env.REACT_APP_ATIX_CHATBOT_HELP_ID}`} />
      </div>
    </div>
  );
};
export { HelpSectionSliderPure as default };
